import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface AlterarResultadoModalProps {
    show: boolean;
    handleClose: () => void;
    handleConfirm: (resultado: string) => void;
    nomeCandidato: string;
    resultadoAtual: string | null;
}

const AlterarResultadoModal: React.FC<AlterarResultadoModalProps> = ({
    show,
    handleClose,
    handleConfirm,
    nomeCandidato,
    resultadoAtual
}) => {
    const [resultado, setResultado] = React.useState<string>(resultadoAtual || '');

    React.useEffect(() => {
        setResultado(resultadoAtual || '');
    }, [resultadoAtual]);

    const handleSubmit = () => {
        if (resultado) {
            handleConfirm(resultado);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Alterar Resultado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><strong>Candidato:</strong> {nomeCandidato}</p>
                <Form.Group>
                    <Form.Label>Resultado</Form.Label>
                    <Form.Select 
                        value={resultado} 
                        onChange={(e) => setResultado(e.target.value)}
                    >
                        <option value="">Selecione...</option>
                        <option value="VALIDADO">Validado</option>
                        <option value="NAO_VALIDADO">Não validado</option>
                        <option value="AUSENTE">Ausente</option>
                        <option value="INCONCLUSIVO">Inconclusivo</option>
                        <option value="VALIDADO_ANTERIORMENTE">Validado anteriormente</option>
                    </Form.Select>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button 
                    variant="primary" 
                    onClick={handleSubmit}
                    disabled={!resultado}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AlterarResultadoModal;
